// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.personsHeaderList {
  width: 100%;
  background-color: white;
  color: #007566;
  padding: 10px;
  font-size: 18px;
  font-weight: bold;
  margin: 5px auto;
}

.personsSubHeader {
  background-color: white;
  font-weight: bold;
  width: 100%;
  padding-right: 13px;
  height: 50px;
  border-bottom: 2px solid #F7F5F2;
  padding-top: 10px;
}

.jobSatisfactionText {
  padding: 15px;
  margin-top: 5px;
}

.prbDate {
  padding-top: 5px;
  padding-right: 15px;
  font-family: MontserratSemiBold, sans-serif;
}

.subsubHeader {
  font-family: MontserratSemiBold, sans-serif;
  font-size: 14pt;
}

.orangeTitleLink {
  padding-top: 8px;
  font-family: MontserratSemiBold, sans-serif;
  text-decoration: none;
  cursor: pointer;
}

.orangeTitleLink:hover {
  text-decoration: underline;
  cursor: pointer;
}

.box {
  border: 4px solid #ddd;
  padding: 20px;
  margin-bottom: 15px;
}

.buttons {
  width: 100%;
}

.button {
  margin-top: 10px;
  padding: 10px;
  color: white;
  width: calc(50% - 5px);
  text-align: center;
  background: #666;
  cursor: pointer;
}

.buttonLarge {
  width: 100%;
}

.button:hover {
  background: #777;
  cursor: pointer;
}

.redButton {
  background: #F07B7E;
}

.redButton:hover {
  background: #ef9799;
}

.personContainer {
  position: relative;
  width: calc(60% - 5px);
}`, "",{"version":3,"sources":["webpack://./src/app/analysis/jobSatisfactions/components/commonClasses/job-satisfactions-person-list-display/job-satisfactions-person-list-display.component.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,uBAAA;EACA,cAAA;EACA,aAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;AACJ;;AAEA;EACI,uBAAA;EACA,iBAAA;EACA,WAAA;EACA,mBAAA;EACA,YAAA;EACA,gCAAA;EACA,iBAAA;AACJ;;AAEA;EACI,aAAA;EACA,eAAA;AACJ;;AAEA;EACI,gBAAA;EACA,mBAAA;EACA,2CAAA;AACJ;;AAEA;EACI,2CAAA;EACA,eAAA;AACJ;;AAEA;EACI,gBAAA;EACA,2CAAA;EACA,qBAAA;EACA,eAAA;AACJ;;AAEA;EACI,0BAAA;EACA,eAAA;AACJ;;AAEA;EACI,sBAAA;EACA,aAAA;EACA,mBAAA;AACJ;;AAGA;EACI,WAAA;AAAJ;;AAGA;EACI,gBAAA;EACA,aAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AAAJ;;AAGA;EACI,WAAA;AAAJ;;AAGA;EACI,gBAAA;EACA,eAAA;AAAJ;;AAGA;EACI,mBAAA;AAAJ;;AAGA;EACI,mBAAA;AAAJ;;AAGA;EACI,kBAAA;EACA,sBAAA;AAAJ","sourcesContent":[".personsHeaderList {\n    width: 100%;\n    background-color: white;\n    color: #007566;\n    padding: 10px;\n    font-size: 18px;\n    font-weight: bold;\n    margin: 5px auto;\n}\n\n.personsSubHeader {\n    background-color: white;\n    font-weight: bold;\n    width: 100%;\n    padding-right: 13px;\n    height: 50px;\n    border-bottom: 2px solid #F7F5F2;\n    padding-top: 10px;\n}\n\n.jobSatisfactionText {\n    padding: 15px;\n    margin-top: 5px;\n}\n\n.prbDate {\n    padding-top: 5px;\n    padding-right: 15px;\n    font-family: MontserratSemiBold,  sans-serif;\n}\n\n.subsubHeader {\n    font-family: MontserratSemiBold,  sans-serif;\n    font-size: 14pt;\n}\n\n.orangeTitleLink {\n    padding-top: 8px;\n    font-family: MontserratSemiBold,  sans-serif;\n    text-decoration: none;\n    cursor: pointer;\n}\n\n.orangeTitleLink:hover {\n    text-decoration: underline;\n    cursor: pointer;\n}\n\n.box {\n    border: 4px solid #ddd;\n    padding: 20px;\n    margin-bottom: 15px;\n}\n\n\n.buttons {\n    width: 100%;\n}\n\n.button {\n    margin-top: 10px;\n    padding: 10px;\n    color: white;\n    width: calc(50% - 5px);\n    text-align: center;\n    background: #666;\n    cursor: pointer;\n}\n\n.buttonLarge {\n    width: 100%;\n}\n\n.button:hover {\n    background: #777;\n    cursor: pointer;\n}\n\n.redButton {\n    background: #F07B7E;\n}\n\n.redButton:hover {\n    background: #ef9799;\n}\n\n.personContainer {\n    position: relative;\n    width: calc(60% - 5px);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
